<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <v-select :id="id" v-bind="$attrs" ref="input" class="form-select2 " :class="{ error: error }" v-on="$listeners">
      <template v-for="(_, slot) in $slots">
        <template :slot="slot">
          <slot :name="slot" />
        </template>
      </template>
    </v-select>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${this._uid}`
      },
    },
    label: String,
    error: String,
  },
  data() {
    return {
      selected: this.value,
    }
  },

  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>

<style>
  .form-select2 .vs__search::placeholder,
  .form-select2 .vs__dropdown-toggle,
  .form-select2 .vs__dropdown-menu {
    background: white;
    border: none;
    color: #394066;
    text-transform: lowercase;

  }

  .form-select2 {
      padding: 4px !important;
  }

  .form-select2 .vs__clear,
  .form-select2 .vs__open-indicator {
    fill: #394066;
  }
</style>

